export enum IntakeWorkflowConfig {    
    ContactBased = 0,
    EmrBased = 1
}